import { SET_IS_APP_READY, SET_PAGE_TITLE, SET_USER_ID_CLAIMS_NAME } from 'store/general/types';
import { getDeals } from 'store/deals/actions';
import { getFieldOptions } from 'store/field-options/actions';
import { getMarkers } from 'store/formula-entry/actions';
import { getCostFormulas } from 'store/cost-formulas/actions';
import { getBookmarks } from 'store/bookmark/actions';
import { handleError } from 'lib/helpers/error-handler';
import { setLoading } from 'store/loading/actions';
import { ELoadingType } from 'store/loading/types';
import { ThunkDispatch } from 'redux-thunk';
import { AnyAction } from 'redux';
import { IStoreState } from 'store';
import history from 'lib/history';
import routes from 'router/routes';
import { setSidebarHeaderVisibility } from 'store/sidebar/actions';

export function setPageTitle(pageTitle: string) {
  return {
    type: SET_PAGE_TITLE,
    pageTitle,
  };
}

export function setUserIdClaimsName(userIdClaimsName: string) {
  return {
    type: SET_USER_ID_CLAIMS_NAME,
    userIdClaimsName,
  };
}

export const initializeApp = () => (dispatch: ThunkDispatch<IStoreState, void, AnyAction>) =>
  new Promise<void>((resolve, reject) => {
    dispatch(setLoading(ELoadingType.OPENING_IMAGE));
    // add logic here to redirect to unauthorized page if user is not authorized
    Promise.all([
      dispatch(getDeals()),
      dispatch(getFieldOptions()),
      dispatch(getMarkers()),
      dispatch(getCostFormulas()),
      dispatch(getBookmarks()),
    ])
      .then(() => {
        dispatch({ type: SET_IS_APP_READY, isAppReady: true });
        dispatch(setSidebarHeaderVisibility(true));
        resolve();
      })
      .catch(error => {
        if (error.includes('401')) {
          history.push(routes.unauthorized);
        } else {
          handleError(error);
        }
        reject(error);
      })
      .finally(() => dispatch(setLoading(ELoadingType.NONE)));
  });
